import styled from 'styled-components' 


export default styled.h1`
    @import url('https://fonts.googleapis.com/css2?family=Chela+One&family=Odibee+Sans&display=swap');
    text-align:center;
    color: white;
    font-family: 'Chela One', cursive;
    font-size: 2.5rem;
    padding:20px;
    background-color:black;
    margin-bottom: 0;
`;
